// extracted by mini-css-extract-plugin
export default {"container":"Store_container__Mhy53"};